export enum aiAgentsPaths {
  INDEX = '',
  SCRIPT = '/:id/script',
  RESULT = '/:id/result'
}
